import axios from 'axios';
import Highcharts from 'highcharts';
import moment from 'moment';

window.Highcharts = Highcharts;
const borderRadius = require('highcharts-border-radius');

// need to update as per env
const baseURL = 'https://physee-orchestrator.azurewebsites.net';
borderRadius(Highcharts);

function updateChart(data) {
  // Updates the data in the chart and redraws
  const highestCloudCoverageValue = Math.min(...data[1].map((i) => i.value)) > 50 ? 50 : 5;
  const energyConsumptionData = data[0].map((i) => ({
    x: i.timestamp,
    y: i.value === 0 ? 1.5 : i.value * highestCloudCoverageValue,
    color: '#fba39a',
  }));
  const cloudCoverageData = data[1].map((i) => ({
    x: i.timestamp,
    y: i.value,
    color: '#80d6dc',
  }));

  Highcharts.chart('chart-container', {
    chart: {
      zoomType: 'xy',
      height: '70%',
    },
    title: {
      text: '',
    },
    subtitle: {
      text: '',
    },
    xAxis: {
      type: 'datetime',
      labels: {
        formatter() {
          return Highcharts.dateFormat('%H:%M', this.value);
        },
      },
      title: {
        text: '',
      },
    },
    yAxis: [
      {
        // Primary yAxis
        labels: {
          enabled: false,
        },
        title: {
          text: '',
        },
      },
      {
        // Secondary yAxis
        title: {
          text: '',
        },
        labels: {
          enabled: false,
        },
      },
    ],
    tooltip: {
      enabled: false,
    },
    legend: {
      enabled: false,
      align: 'right',
      layout: 'horizontal',
      verticalAlign: 'bottom',
      x: -50,
      y: 0,
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: 'CloudCoverage',
        type: 'areaspline',
        data: cloudCoverageData,
      },
      {
        name: 'EnergyConsumption',
        type: 'column',
        data: energyConsumptionData,
      },
    ],
    plotOptions: {
      series: {
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1,
          },
          stops: [
            [0, '#80d6dc'],
            [1, '#ffffff'],
          ],
        },
        lineColor: '#80d6dc',
        marker: {
          enabled: false,
          states: {
            hover: {
              enabled: false,
            },
          },
        },
      },
    },
  });
}

function subtractHours(numOfHours) {
  return moment(new Date(), 'HH:mm').subtract(numOfHours, 'hours').unix() * 1000;
}

function fetchChartDataAndUpdate() {
  // 1. Calculate start date from end date with interval
  const date = new Date();
  const startDate = subtractHours(12);
  const endDate = date;
  // 2. fetch data from api
  const axiosInstance = axios.create({
    headers: { 'x-project-slug': 'bold' },
  });

  const consumptionRequest = axiosInstance.get(
    `${baseURL}/energy/victron/consumption?from=${startDate}&to=${endDate.getTime()}`
  );
  const cloudCoverageRequest = axiosInstance.get(
    `${baseURL}/weather/cloud-coverage?from=${startDate}`
  );

  axios
    .all([consumptionRequest, cloudCoverageRequest])
    .then(
      axios.spread((...responses) => {
        // use/access the results
        updateChart(responses.map((i) => i.data));
      })
    )
    .catch((errors) => {
      // react on errors.
    })
    .catch((err) => {
      console.error(err);
    });
}

fetchChartDataAndUpdate();



// WEBPACK FOOTER //
// ./public/javascripts/modules/charts.js